<script>

    export let label = ''
    export let icon = ''
    export let placeholder = ''
    export let iconType = 'fa'
    export let value = ''
    export let rows = ''
    export let maxlength = null
    export let minlength = null
    export let required = true
    export let readonly = false

    let isValid = true

    if(value)
        verifyTextarea() 

    function verifyTextarea() {

        if(maxlength && minlength)
            return isValid = (value.length >= minlength && value.length <= maxlength) ? false : true

        if(maxlength)
            return isValid = (value.length > 0  && value.length <= maxlength) ? false : true

        if(minlength)
            return isValid = value.length >= minlength ? false : true

        return isValid = false

    }

</script>

<div class="field">
    {#if label}
        <label for="" class="label">{ label }</label>
    {/if}
        <div class="control" class:has-icons-left={ icon }>
            {#if icon}
                <span class="icon"><i class="fa { iconType }-{ icon }"></i></span>
            {/if}
            <textarea on:keyup={ verifyTextarea } bind:value={value} class="textarea" { readonly }  { maxlength } { minlength } { rows } { placeholder } { required } class:is-invalid={ required && isValid }></textarea>
        </div>
    {#if maxlength}
        <div class="items end">
            <small>{ value.length || 0 } / { maxlength } caracteres </small>
        </div>
    {/if}
</div>